import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { HomeComponent } from './home/home.component';
import { ThankYouComponent } from '../shop/thank-you/thank-you.component';
import { AboutComponent } from './about/about.component';
import { AuxiliaryEquipmentComponent } from './capability/auxiliary-equipment/auxiliary-equipment.component';
import { CoatingsComponent } from './capability/coatings/coatings.component';
import { DieCastingComponent } from './capability/die-casting/die-casting.component';
import { ElastomerComponent } from './capability/elastomer/elastomer.component';
import { IndirectSolutionsComponent } from './capability/indirect-solutions/indirect-solutions.component';
import { InjectionMouldingMachineComponent } from './capability/injection-moulding-machine/injection-moulding-machine.component';
import { MaterialHandlingComponent } from './capability/material-handling/material-handling.component';
import { MetalMachiningComponent } from './capability/metal-machining/metal-machining.component';
import { MetalStampingComponent } from './capability/metal-stamping/metal-stamping.component';
import { ModlingMachineEnhancementComponent } from './capability/modling-machine-enhancement/modling-machine-enhancement.component';
import { MouldingToolsManufacturingComponent } from './capability/moulding-tools-manufacturing/moulding-tools-manufacturing.component';
import { PaintingEquipmentComponent } from './capability/painting-equipment/painting-equipment.component';
import { PlasticPartProcessingComponent } from './capability/plastic_part_processing/plastic-part-processing.component';
import { RawMaterialComponent } from './capability/raw-material/raw-material.component';
import { RobotProcessAutomationComponent } from './capability/robot-process-automation/robot-process-automation.component';
import { SinteredMetalPartComponent } from './capability/sintered_metal_parts/sintered-metal-part.component';
import { SurfaceFinishingComponent } from './capability/surface-finishing/surface-finishing.component';
import { WireWiringHarnessComponent } from './capability/wires_wiring_harness/wire-wiring-harness.component';
import { CareerDetailComponent } from './career-detail/career-detail.component';
import { CareerComponent } from './career/career.component';
import { ContactComponent } from './contact/contact.component';
import { CookiesPolicyComponent } from './cookies-policy/cookies-policy.component';
import { DisclaimerComponent } from './disclaimer/disclaimer.component';
import { PrivacyPolicyComponent } from './privacy-policy/privacy-policy.component';
import { ServiceDetailComponent } from './service-detail/service-detail.component';
import { ServiceComponent } from './service/service.component';
import { TermsComponent } from './terms/terms.component';
import { VideoLaunchComponent } from './video-launch/video-launch.component';
import { TeamsComponent } from './teams/teams.component';
import { PolicyComponent } from './policy/policy.component';

const routes: Routes = [
      { path: 'about', component: HomeComponent  },
      //{ path: 'about', component: AboutComponent },
      { path: 'services', component:ServiceComponent}, 
      { path: 'cnc-machining', component: ServiceDetailComponent },  
      { path: 'terms-conditions', component: TermsComponent },
      { path: 'disclaimer', component: DisclaimerComponent },
      { path: 'contact', component: ContactComponent },
      { path: 'privacy-and-cookies-policy', component: PrivacyPolicyComponent },
      { path: 'coo-policy', component: CookiesPolicyComponent },
      
      { path: 'elastomer', component: ElastomerComponent },
      { path: 'plasticpart', component: PlasticPartProcessingComponent },
      { path: 'sinteredmetalpart', component: SinteredMetalPartComponent },
      { path: 'wiringharness', component: WireWiringHarnessComponent },
      { path: 'indirectsolutions', component: IndirectSolutionsComponent },
      { path: 'rawmaterial', component: RawMaterialComponent },
      { path: 'coating', component: CoatingsComponent },
      { path: 'metalmachining', component: MetalMachiningComponent },
      { path: 'diecasting', component: DieCastingComponent },
      { path: 'metalstamping', component: MetalStampingComponent },
      { path: 'surfacefinishing', component: SurfaceFinishingComponent },
      { path: 'paintingequipment', component: PaintingEquipmentComponent },
      { path: 'materialhandling', component: MaterialHandlingComponent },
      { path: 'injectionmouldingmachine', component: InjectionMouldingMachineComponent },
      { path: 'auxilaryepuipment', component: AuxiliaryEquipmentComponent },
      { path: 'mouldingtoolsmanufacturing', component: MouldingToolsManufacturingComponent },
      { path: 'robotprocess', component: RobotProcessAutomationComponent },
      { path: 'moldingmachineenhancement', component: ModlingMachineEnhancementComponent },
      { path: 'video', component: VideoLaunchComponent },
      {path: 'career', component:CareerComponent},
      {path: 'career-detail/:id', component:CareerDetailComponent},
      {path: 'teams', component:TeamsComponent},
      {path:'thank-you', component:ThankYouComponent},
      {path:'policy', component:PolicyComponent},

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class MainModuleRoutingModule { }
